import React from "react";
import logger from "logger";

import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import HeroNameSelector from "TaskDialogCommon/HeroNameSelector";
import CitySelector from "TaskDialogCommon/CitySelector";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import Warning from "TaskDialogCommon/Warning";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "cgbuff";

export default class CGBuffDialog extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        atkheroname: "",
        targetcity: null,
        unboxtroops: true,
      },
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  validate = () => {
    const {
      taskConfig: { atkheroname, targetcity },
    } = this.state;
    if (!atkheroname || atkheroname.length === 0) {
      alert("Please select a hero before continuing");
      return false;
    }
    if (!targetcity) {
      alert("Please select a target city before continuing");
      return false;
    }
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      logger.log("storeddata", storeddata, accountdetail);
      if (storeddata) {
        for (var key in accountdetail.heroes) {
          logger.log("key", key);
          var cityObj = accountdetail.heroes[key];
          logger.log("cityObj", cityObj);
          if (cityObj.cityname === storeddata.targetcity.cityname) {
            taskConfig.targetcity = cityObj;
          }
          for (var hkey in cityObj.cityheroes) {
            var heroObj = cityObj.cityheroes[hkey];
            if (heroObj.heroname === storeddata.atkheroname) {
              taskConfig.atkheroname = storeddata.atkheroname;
            }
          }
        }
        taskConfig.unboxtroops = storeddata.unboxtroops;
        logger.log("final taskconfig", taskConfig);
      }
    } catch (e) {
      logger.log("loadStoredData", e);
    }
  };

  render = () => {
    const {
      setValue,
      validate,
      state: { taskConfig },
      props: { AccountDetailData },
    } = this;
    return (
      <TaskDialog heading={"City Guardian Buff"}>
        <HeroNameSelector
          label={"Select Hero To Farm"}
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          param={"atkheroname"}
        />
        <CitySelector
          label={"Select City to Do Buffs for"}
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          param={"targetcity"}
        />
        <TaskCheckBox
          label={"Auto Unbox Troops when needed"}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />
        <Warning>
          *Any city whose hero participates in farming city buff items MUST
          contain 500k+ MRS and 300K+ SGS.
          <br /> *Make sure runes are popped enough if your hero is weak and you
          feel runes will be needed.
        </Warning>
        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run CG Farming"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
